import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PaymentOnboardingProcessing from "../../assets/img/PaymentOnboardingProcessing.svg";
import Settings from '../../services/settings.service';
import DownloadApps from '../shared/DownloadApps';
const subscriptions = [];
const PaymentProcessing = props => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})

    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        // GTMService.action_gtm_on_payment_done();
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);

    return (<div className="payment-summary-success-failure">
        <div className="payment-summary-failure processing">
            <img src={PaymentOnboardingProcessing} alt={""}></img>
            <div className='payment-success-title'>
                {translationKeys["payment_validation_processing"] || "Payment is processing"}
            </div>
            <div className='payment-success-desc'>
                {translationKeys["payment_validation_processing_desc"] || "Your payment is currently being processed. Please wait for confirmation."}
            </div>
            {/* <button className="common-button"> {translationKeys["buttons_continue"]}</button> */}
            <DownloadApps
                info={translationKeys["scr_3.3.3_app_download_info"]}
                classes={"download-apps"}
                google_play_link={Settings.google_play_link}
                app_store_link={Settings.app_store_link}
                huawei_store_link={Settings.huawei_store_link}
            />
        </div>
    </div>
    )
}

export default PaymentProcessing;